// src/config/firebase.ts
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBG7PFeMSy2p0XUmNdXNf9z0PTNUV2vWxo",
  authDomain: "switchr-web-app-dev.firebaseapp.com",
  projectId: "switchr-web-app-dev",
  storageBucket: "switchr-web-app-dev.firebasestorage.app",
  messagingSenderId: "1079310183956",
  appId: "1:1079310183956:web:fe3a2b867977dd0f700101",
  tenantId:'switchr-uat-2g0m5',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
auth.tenantId = firebaseConfig.tenantId;

export { auth };